export default __webpack_public_path__ + "static/media/fondo.4296ab7f.jpg";